import type { ComponentSchema } from '../../../../../schema-types'
import { schema as accountSchema } from './account.schema'
import { schema as cartSchema } from './cart.schema'
import { schema as checkoutSchema } from './checkout.schema'
import { schema as contactSchema } from './contact.schema'
import { schema as contentSchema } from './content.schema'
import { schema as couponSchema } from './coupon.schema'
import { schema as orderSuccessSchema } from './order-success.schema'
import { schema as signinSchema } from './signin.schema'
import { schema as signupSchema } from './signup.schema'

/** Cart, checkout, order success, track order, coupon, account, auth and content pages. */
export const purchaseSchemas: Record<string, ComponentSchema> = {
  'cart': cartSchema,
  'checkout': checkoutSchema,
  'order-success': orderSuccessSchema,
  'coupon': couponSchema,
  'account': accountSchema,
  'signin': signinSchema,
  'signup': signupSchema,
  'contact': contactSchema,
  'content': contentSchema,
}
